import { useParams } from "react-router-dom";
import { InterviewType } from "../../graphql/generated/graphql";
import { useTerm } from "../../hooks";
import { StakeholderTermDetail } from "../StakeholderTermDetail";
import { TermDetail } from "../TermDetail";

/**
 * ターム詳細の振り分け。
 *
 * 従業員インタビューとステークホルダーインタビューは扱う要素が異なり、それぞれ専用の
 * データを取得するため、種別を先に確定させてから対応するページを描画する。
 */
export function TermDetailRoute() {
  const { termId } = useParams<{ termId: string }>();
  const { term, loading, error } = useTerm(termId ?? null);

  if (loading) {
    return (
      <div className="min-h-[calc(100vh-200px)] bg-[var(--color-bg-subtle-gray)] p-6">
        <div className="p-10 text-center font-medium text-[var(--color-text-secondary)]">
          読み込み中...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-[calc(100vh-200px)] bg-[var(--color-bg-subtle-gray)] p-6">
        <div className="p-10 text-center font-medium text-[#ef4444]">
          {error}
        </div>
      </div>
    );
  }

  if (term?.interviewType === InterviewType.Stakeholder) {
    return <StakeholderTermDetail />;
  }
  return <TermDetail />;
}
